import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { extentContainsPoint as n, polygonContainsCoords as t, extentContainsCoords2D as e, extentContainsCoords3D as r } from "./contains.js";

function i(t, e) {
  return n(t, e);
}

function o(n, t) {
  var e = n.hasZ && t.hasZ;
  var r, i, o;

  if (n.xmin <= t.xmin) {
    if (r = t.xmin, n.xmax < r) return !1;
  } else if (r = n.xmin, t.xmax < r) return !1;

  if (n.ymin <= t.ymin) {
    if (i = t.ymin, n.ymax < i) return !1;
  } else if (i = n.ymin, t.ymax < i) return !1;

  if (e && t.hasZ) if (n.zmin <= t.zmin) {
    if (o = t.zmin, n.zmax < o) return !1;
  } else if (o = n.zmin, t.zmax < o) return !1;
  return !0;
}

function f(n, t) {
  var i = t.points,
      o = t.hasZ,
      f = o ? r : e;

  var _iterator = _createForOfIteratorHelper(i),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _e = _step.value;
      if (f(n, _e)) return !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !1;
}

var s = [0, 0],
    c = [0, 0],
    m = [0, 0],
    u = [0, 0],
    l = [s, c, m, u],
    a = [[m, s], [s, c], [c, u], [u, m]];

function x(n, r) {
  s[0] = n.xmin, s[1] = n.ymax, c[0] = n.xmax, c[1] = n.ymax, m[0] = n.xmin, m[1] = n.ymin, u[0] = n.xmax, u[1] = n.ymin;

  var _iterator2 = _createForOfIteratorHelper(l),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _e2 = _step2.value;
      if (t(r, _e2)) return !0;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(r.rings),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t = _step3.value;
      if (!_t.length) continue;
      var _r = _t[0];
      if (e(n, _r)) return !0;

      for (var _i = 1; _i < _t.length; _i++) {
        var _o = _t[_i];
        if (e(n, _o) || p(_r, _o, a)) return !0;
        _r = _o;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return !1;
}

function y(n, t) {
  s[0] = n.xmin, s[1] = n.ymax, c[0] = n.xmax, c[1] = n.ymax, m[0] = n.xmin, m[1] = n.ymin, u[0] = n.xmax, u[1] = n.ymin;
  var r = t.paths;

  var _iterator4 = _createForOfIteratorHelper(r),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _i2 = _step4.value;
      if (!r.length) continue;
      var _t2 = _i2[0];
      if (e(n, _t2)) return !0;

      for (var _r2 = 1; _r2 < _i2.length; _r2++) {
        var _o2 = _i2[_r2];
        if (e(n, _o2) || p(_t2, _o2, a)) return !0;
        _t2 = _o2;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return !1;
}

var h = [0, 0];

function g(n) {
  for (var _t3 = 0; _t3 < n.length; _t3++) {
    var _e3 = n[_t3];

    for (var _i3 = 0; _i3 < _e3.length - 1; _i3++) {
      var _r4 = _e3[_i3],
          _o3 = _e3[_i3 + 1];

      for (var _e4 = _t3 + 1; _e4 < n.length; _e4++) {
        for (var _t4 = 0; _t4 < n[_e4].length - 1; _t4++) {
          var _i4 = n[_e4][_t4],
              _f = n[_e4][_t4 + 1];
          if (z(_r4, _o3, _i4, _f, h) && !(h[0] === _r4[0] && h[1] === _r4[1] || h[0] === _i4[0] && h[1] === _i4[1] || h[0] === _o3[0] && h[1] === _o3[1] || h[0] === _f[0] && h[1] === _f[1])) return !0;
        }
      }
    }

    var _r3 = _e3.length;
    if (!(_r3 <= 4)) for (var _n = 0; _n < _r3 - 3; _n++) {
      var _t5 = _r3 - 1;

      0 === _n && (_t5 = _r3 - 2);
      var _i5 = _e3[_n],
          _o4 = _e3[_n + 1];

      for (var _r5 = _n + 2; _r5 < _t5; _r5++) {
        var _n2 = _e3[_r5],
            _t6 = _e3[_r5 + 1];
        if (z(_i5, _o4, _n2, _t6, h) && !(h[0] === _i5[0] && h[1] === _i5[1] || h[0] === _n2[0] && h[1] === _n2[1] || h[0] === _o4[0] && h[1] === _o4[1] || h[0] === _t6[0] && h[1] === _t6[1])) return !0;
      }
    }
  }

  return !1;
}

function p(n, t, e) {
  for (var _r6 = 0; _r6 < e.length; _r6++) {
    if (z(n, t, e[_r6][0], e[_r6][1])) return !0;
  }

  return !1;
}

function z(n, t, e, r, i) {
  var _n3 = _slicedToArray(n, 2),
      o = _n3[0],
      f = _n3[1],
      _t7 = _slicedToArray(t, 2),
      s = _t7[0],
      c = _t7[1],
      _e5 = _slicedToArray(e, 2),
      m = _e5[0],
      u = _e5[1],
      _r7 = _slicedToArray(r, 2),
      l = _r7[0],
      a = _r7[1],
      x = l - m,
      y = o - m,
      h = s - o,
      g = a - u,
      p = f - u,
      z = c - f,
      G = g * h - x * z;

  if (0 === G) return !1;
  var Z = (x * p - g * y) / G,
      P = (h * p - z * y) / G;
  return Z >= 0 && Z <= 1 && P >= 0 && P <= 1 && (i && (i[0] = o + Z * (s - o), i[1] = f + Z * (c - f)), !0);
}

function G(n) {
  switch (n) {
    case "esriGeometryEnvelope":
    case "extent":
      return o;

    case "esriGeometryMultipoint":
    case "multipoint":
      return f;

    case "esriGeometryPoint":
    case "point":
      return i;

    case "esriGeometryPolygon":
    case "polygon":
      return x;

    case "esriGeometryPolyline":
    case "polyline":
      return y;
  }
}

export { o as extentIntersectsExtent, f as extentIntersectsMultipoint, i as extentIntersectsPoint, x as extentIntersectsPolygon, y as extentIntersectsPolyline, G as getFeatureExtentIntersector, g as isSelfIntersecting, z as segmentIntersects };